module.exports = __webpack_public_path__ + "static/OLAgg-06c4290d2616d8fbf338b5ee4d38f97f.png";